export class Station {
    public detail : StationDetail;

    public setDetail(detail) {
        this.detail = detail;
    }

    constructor(
        public autonomy: number,
        public available: boolean,
        public car_name: string,
        public guest_booking: any,
        public id: number,
        public latitude: any = 0,
        public longitude: any = 0,
        public name: string,
        public type: number, 
        public info_specific: any,
        ) {
        }

}

export class StationDetailGuest {
    constructor (
        public price : any,
        public description_price_title: string,
        public description_price : string
    ) {}
}

export class Availabilitie {
    constructor(
        public startdate : string,
        public enddate :string
    ) {}
}

export class StationAvailabilities {
    constructor(
        public availabilities: Availabilitie[],
        public distance: any,
        public id: number,
        public latitude: any,
        public longitude: any,
        public name: string,
        public station_name: string,
    ) {
        
    }
}

export class StationPrice {
    constructor(
        public description_price: string,
        public description_price_title: string,
        public price: any,
        public extra: any
    ) {
        
    }
}

export class StationImage{
    constructor(
        public link: boolean,
        public file: string,
        public mimetype: string

    ) {
    }
}

export class StationDetail{
    constructor(
        public autonomy: number,
        public latitude : number,
        public longitude : number,
        public available: boolean,
        public canBook: boolean,
        public cannotBookMessage: any,
        public car_ids: [number],
        public car_name: string,
        public city: string,
        public guest_booking: any,
        public id: number,
        public id_ocpp: string,
        public image: StationImage,
        public info_specific: any,
        public name: string,
        public nbplace: number,
        public station_name: any,
        public street: string,
        public type: number,
        public wifi_bssid: any,
        public wifi_encryption: any,
        public wifi_key: any,
        public wifi_ssid: any,
        public wifi_type: any,
        public zipcode: string,
        public id_pl: number,
        public guid: string,
        public modeaccess: number,
        public subscription_community: string,
        public immediate_service: boolean,
    ) {}
}